import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

export function registerIcons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
  return () => {
    const icons = [
      { name: 'custom-document', url: '/assets/images/document.svg' },
      { name: 'custom-claim', url: '/assets/images/claim.svg' },
      { name: 'custom-eligibility', url: '/assets/images/eligibility.svg' },
      { name: 'custom-preauth', url: '/assets/images/preauth.svg' },
      { name: 'custom-convert-preauth', url: '/assets/images/convert-preauth.svg' },
      { name: 'hand-holding-usd', url: '/assets/images/hand-holding-usd.svg' },
      { name: 'faq', url: '/assets/images/faq.svg' },
      { name: 'custom-payment', url: '/assets/images/custom-payment.svg' },
      { name: 'custom-reconciliation', url: '/assets/images/custom-reconciliation.svg' },
      { name: 'custom-prescription', url: '/assets/images/prescription.svg' },
      { name: 'custom-business-building', url: '/assets/images/ic-insurance-com.svg' },
      { name: 'custom-link-mapping', url: '/assets/images/ic-link-active.svg' },
      { name: 'custom-payer-provider-mapping', url: '/assets/images/payer-provider-mapping.svg' },
      { name: 'settings', url: 'assets/images/settings.svg' },
      { name: 'sync', url: 'assets/images/sync.svg' },
      { name: 'custom-network', url: 'assets/images/network.svg' },
      { name: 'custom-discover-tune', url: 'assets/images/discover-tune.svg' },
      { name: 'custom-notifications', url: 'assets/images/notifications.svg' },
      { name: 'custom-notes', url: 'assets/images/ic-notes.svg' },
      { name: 'custom-comment', url: 'assets/images/ic-comment.svg' },
      { name: 'custom-chart-data', url: 'assets/images/ic-chart-data.svg' },
    ];
    icons.forEach(icon => {
      iconRegistry.addSvgIcon(
        icon.name,
        sanitizer.bypassSecurityTrustResourceUrl(icon.url)
      );
    });
  };
}
